import * as sections from 'constants/sections';

export const REVIEW_AND_SUBMIT = {
  key: sections.REVIEW_AND_SUBMIT,
  name: 'review',
  path: 'package',
  store: 'Package',
  label: 'Review and submit',
};

export const REVIEW_AND_SUBMIT_COMMENTS = {
  key: sections.REVIEW_AND_SUBMIT_COMMENTS,
  name: 'comments',
  path: 'comments',
  storeKey: 'Comments',
  label: 'Additional Comments',
};

export const REVIEW_AND_SUBMIT_REVIEW = {
  key: sections.REVIEW_AND_SUBMIT_REVIEW,
  name: 'review',
  path: 'review',
  label: 'Review',
};

export const REVIEW_AND_SUBMIT_SUBMIT = {
  key: sections.REVIEW_AND_SUBMIT_SUBMIT,
  name: 'submit',
  path: 'submit',
  label: 'Submit',
};

export const REVIEW_AND_SUBMIT_PRINT = {
  key: sections.REVIEW_AND_SUBMIT_PRINT,
  name: 'print',
  path: 'print',
  label: 'Print',
};

export default {
  REVIEW_AND_SUBMIT,
  REVIEW_AND_SUBMIT_COMMENTS,
  REVIEW_AND_SUBMIT_REVIEW,
  REVIEW_AND_SUBMIT_SUBMIT,
  REVIEW_AND_SUBMIT_PRINT,
};
